<div [ngClass]="{'flex items-center gap-3.5': linear()}">
  @if (label()) {
    <div class="text-base" [ngClass]="{'mb-2.5': !linear()}">{{ label() }}</div>
  }
  <div class="flex flex-wrap items-center gap-3.5 font-medium">
    @for (option of options(); track option.value) {
      <div class="flex items-center gap-1.5">
        <input type="radio" [name]="name()" [id]="option.value" [value]="option.value"
               (change)="onChangeValue(option.value)" class="hidden">
        <label [for]="option.value"
               class="relative bg-white cursor-pointer border w-4 h-4 lg:w-5 lg:h-5 rounded-full border-main-500 flex items-center justify-center">
          <div
            class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 w-2/3 h-2/3 rounded-full bg-main-500"
            [ngClass]="[selectedValue === option.value ? 'scale-100 transition' : 'scale-0']"></div>
        </label>
        <label [for]="option.value" class="cursor-pointer">{{ option.label }}</label>
      </div>
    }
  </div>
</div>
